module.exports = __webpack_public_path__ + "img/faq.fe37815.png";